/* eslint-disable import/prefer-default-export */
export const API_KEY = process.env.REACT_APP_API_KEY_TINY
